(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("BadgeEditor"));
	else if(typeof define === 'function' && define.amd)
		define(["BadgeEditor"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("BadgeEditor")) : factory(root["BadgeEditor"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__19657__) => {
return 